export default "__VITE_ASSET__BwcNTyPg__"